<script lang="ts">
  import Navbar from '../components/Navbar.svelte';

  // Mock data - replace with actual API call
  let deployments = [
    {
      id: 1,
      project: 'koru-website',
      environment: 'Production',
      status: 'success',
      branch: 'main',
      commit: 'a3f2c1d',
      deployedAt: '2 hours ago',
      url: 'https://koru.io',
      createdAt: new Date('2025-12-23T10:00:00')
    },
    {
      id: 2,
      project: 'api-gateway',
      environment: 'Production',
      status: 'success',
      branch: 'main',
      commit: 'b7e8f2a',
      deployedAt: '5 hours ago',
      url: 'https://api.koru.io',
      createdAt: new Date('2025-12-23T07:00:00')
    },
    {
      id: 3,
      project: 'mobile-app',
      environment: 'Staging',
      status: 'deploying',
      branch: 'develop',
      commit: 'c9d1a3b',
      deployedAt: 'In progress',
      url: 'https://staging.mobile.koru.io',
      createdAt: new Date('2025-12-23T12:00:00')
    }
  ];

  function getStatusInfo(status: string) {
    switch (status) {
      case 'success':
        return { text: 'Live', color: 'bg-green-500', textColor: 'text-green-700 dark:text-green-400', bgColor: 'bg-green-50 dark:bg-green-900/20' };
      case 'deploying':
        return { text: 'Deploying', color: 'bg-blue-500', textColor: 'text-blue-700 dark:text-blue-400', bgColor: 'bg-blue-50 dark:bg-blue-900/20' };
      case 'failed':
        return { text: 'Failed', color: 'bg-red-500', textColor: 'text-red-700 dark:text-red-400', bgColor: 'bg-red-50 dark:bg-red-900/20' };
      default:
        return { text: 'Unknown', color: 'bg-gray-500', textColor: 'text-gray-700 dark:text-gray-400', bgColor: 'bg-gray-50 dark:bg-gray-800' };
    }
  }
</script>

<Navbar />

<div class="min-h-screen bg-gray-50 dark:bg-gray-900">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <div class="flex items-center justify-between mb-8">
      <div>
        <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-100">Deployments</h1>
        <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">Manage and monitor your application deployments</p>
      </div>
      <a href="#/deployments/new" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
        </svg>
        New Deployment
      </a>
    </div>

    <div class="bg-white dark:bg-gray-800 shadow-sm rounded-lg border border-gray-200 dark:border-gray-700">
      <div class="divide-y divide-gray-200 dark:divide-gray-700">
        {#each deployments as deployment}
          <div class="p-6 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
            <div class="flex items-start justify-between">
              <div class="flex-1 min-w-0">
                <div class="flex items-center space-x-3 mb-2">
                  <h3 class="text-base font-semibold text-gray-900 dark:text-gray-100">
                    {deployment.project}
                  </h3>
                  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium {getStatusInfo(deployment.status).textColor} {getStatusInfo(deployment.status).bgColor}">
                    <span class="w-2 h-2 {getStatusInfo(deployment.status).color} rounded-full mr-1.5"></span>
                    {getStatusInfo(deployment.status).text}
                  </span>
                  <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                    {deployment.environment}
                  </span>
                </div>

                <div class="flex items-center space-x-4 text-sm text-gray-600 dark:text-gray-300 mb-2">
                  <span class="flex items-center space-x-1">
                    <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                    <span class="font-mono text-xs">{deployment.commit}</span>
                  </span>
                  <span>on {deployment.branch}</span>
                  <span class="text-gray-400 dark:text-gray-500">•</span>
                  <span>{deployment.deployedAt}</span>
                </div>

                {#if deployment.status === 'success'}
                  <a href={deployment.url} target="_blank" rel="noopener noreferrer" class="inline-flex items-center space-x-1 text-sm text-indigo-600 dark:text-blue-400 hover:text-indigo-700 dark:hover:text-blue-300">
                    <span>{deployment.url}</span>
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </a>
                {/if}
              </div>

              <div class="ml-4 flex space-x-2">
                <button class="text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        {/each}
      </div>
    </div>
  </div>
</div>
